import {
  PublicClientApplication,
  InteractionRequiredAuthError,
  type Configuration,
} from '@azure/msal-browser';
import { config } from '../config';

const msalConfig: Configuration = {
  auth: {
    clientId: config.clientId,
    authority: `https://login.microsoftonline.com/${config.tenantId}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    // sessionStorage keeps tokens (incl. the refresh token) tab-scoped instead of
    // persisting them where any injected script could read them long-term. New tabs
    // re-auth silently via the Entra session cookie (acquireTokenRedirect), so the
    // UX cost is one brief redirect per tab, not a credential prompt.
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

export const loginRequest = {
  scopes: ['openid', 'profile', 'offline_access', config.apiScope],
};

/** Acquire an access token for the FABS API; redirects to sign-in if needed. */
export async function getApiToken(): Promise<string> {
  const account = msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
  if (!account) throw new Error('Not signed in');
  try {
    const result = await msalInstance.acquireTokenSilent({ scopes: [config.apiScope], account });
    return result.accessToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      // Navigates away to the IdP and reloads the app; nothing after this runs.
      await msalInstance.acquireTokenRedirect({ scopes: [config.apiScope], account });
      return '';
    }
    throw error;
  }
}
